import React, { ReactElement, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { AiOutlineMail } from "react-icons/ai";
import { BiGroup } from "react-icons/bi";
import { Loading } from "../../../components";
import Avatar from "../../../components/avatar/Avatar";
import { useGetAccountQuery, AgentAssignmentPreference, useSaveUserSettingsMutation } from "../../../__generated__/api";
import Select from "../../../components/select/Select";

const ASSIGNMENT_PREFERENCES = [
    {
        label: "Automatically synchronize",
        value: AgentAssignmentPreference.AutoSynchronize,
    },
    {
        label: "Always available",
        value: AgentAssignmentPreference.Available,
    },
    {
        label: "Always unavailable",
        value: AgentAssignmentPreference.Unavailable,
    },

];

export default function AccountDetails(): ReactElement {
    const { data, loading: isLoading } = useGetAccountQuery();
    const [saveSettings] = useSaveUserSettingsMutation();

    const user = data?.session.user;

    const [assignmentPreference, setAssignmentPreference] = useState(data?.userSettings.assignmentPreference
            ?? AgentAssignmentPreference.AutoSynchronize);
    useEffect(() => {
        if (data?.userSettings?.assignmentPreference) {
            setAssignmentPreference(data.userSettings?.assignmentPreference);
        }
    }, [data]);

    useEffect(() => {
        if (!data || assignmentPreference === data?.userSettings.assignmentPreference) {
            return;
        }
        saveSettings({
            variables: {
                settings: {
                    assignmentPreference,
                },
            },
        });
    }, [assignmentPreference]);

    if (isLoading) {
        return <Loading />;
    }
    if (!user) {
        return <h3 className="text-center text-light mt-3">Not Logged in</h3>;
    }
    return (
        <div className="d-flex h-100">
            <div className="col-xl-2 col-lg-3 col-md-4 p-4 shadow">

                <div className="text-center">
                    <Avatar src={user?.avatarUrl as string} variant="lg" isCircle={false} />

                </div>
                <div>
                    <h3 className="mt-3">
                        {user.name}
                    </h3>

                    <div>
                        {user.emailAddresses?.map(email => (
                            <div key={email}>
                                <AiOutlineMail className="text-light" />
                                {" "}
                                {email}
                            </div>
                        ))}

                        {user.userGroups?.map(group => (
                            <div key={group.id}>
                                <BiGroup className="text-light" />
                                {" "}
                                {group.name}
                            </div>
                        ))}
                    </div>

                </div>
            </div>
            <div className="col shadow p-4 bg-white">
                <h5 className="">
                    Preferences
                </h5>

                <div className="row mt-3 ">
                    <Form.Group className="col-xl-6">

                        <Form.Label className="fw-bolder mt-0">Assignment Availability</Form.Label>

                        <Select
                            className="text-gray"
                            placeholder=""
                            onChange={value => setAssignmentPreference(value.value as AgentAssignmentPreference)}
                            options={ASSIGNMENT_PREFERENCES}
                            value={ASSIGNMENT_PREFERENCES.find(option => option.value === assignmentPreference)}
                        />
                        <Form.Text className="text-light">
                            This setting controlls if tickets should be assigned to you or not. By default, before
                            assigning a ticket to you, Foqal Agent will try to automatically determine if you are
                            available using your status in systems such as Slack.
                            However, you can override this behavior and set yourself as always
                            available or always unavailable.
                        </Form.Text>

                    </Form.Group>

                </div>

            </div>

        </div>
    );
}
